'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InlineTextField = require('./components/InlineTextField.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineTextField).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-inline-text-field/lib/index.js
// module id = 1017
// module chunks = 0